var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
import PubSub from 'pubsub-js';
import Cookies from 'js-cookie';
import { platform_base_url } from './config';
import { post } from './request';
import { isBrowser } from './ssr';
export var CURRENCY_SYMBOL = typeof window !== 'undefined' && ((_b = (_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.active) === 'GBP'
    ? '£'
    : '$';
/**
 * Splits an array into two parts at the specified delimiter.
 * @param {array} list List to split
 * @param {*} delimiter Item used to delimit `list`
 * @returns {array} An array with two subarrays, representing the elements before and elements after `delimiter`.
 */
export var splitArray = function (list, delimiter) {
    if (!list || !Array.isArray(list))
        throw new Error('Calls to #splitArray require a list to split.');
    var delimiterIndex = list.indexOf(delimiter);
    if (delimiterIndex < 0) {
        delimiterIndex = list.length;
    }
    return [list.slice(0, delimiterIndex), list.slice(delimiterIndex + 1)];
};
export var replaceAllSpaces = function (string, replacement) {
    if (string === void 0) { string = ''; }
    if (replacement === void 0) { replacement = '-'; }
    return string.replace(/ /g, replacement);
};
/**
 * A pluralization utility
 * @param {num} amount - the quantity of the item
 * @param {string} item - the object to be pluralized. Must be passed as a singluar object
 * @param {string} modifier [modifier=s] - the plural modifier. Some words might need an 'es' such as tomato vs tomatoes
 * @param {string} override [override=null] - A plural modifier for special cases such as person vs people
 */
export var pluralize = function (amount, item, modifier, override) {
    if (modifier === void 0) { modifier = 's'; }
    if (override === void 0) { override = null; }
    if (amount < 0)
        throw new Error('The amount must be a positive integer');
    if (amount === 1) {
        if (modifier && item.endsWith(modifier)) {
            return item.slice(0, item.length - modifier.length);
        }
        return item;
    }
    if (override) {
        return "".concat(override);
    }
    return "".concat(item).concat(modifier);
};
/**
 * Determines if a string is a hex code
 * @param {string} string - input string to test
 */
export var isHexCode = function (string) {
    return string.includes('#') && (string.length === 7 || string.length === 4);
};
/**
 * Traps focus within an element when a user presses tab
 * @param {SyntheticBaseEvent} e - the keyboard event from the element to trap focus in
 */
export var trapFocusInElement = function (e, targetNode) {
    if (targetNode === void 0) { targetNode = null; }
    var focusableEls = (targetNode || e.currentTarget).querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;
    var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (isTabPressed) {
        if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
        }
    }
};
/**
 * Uses an <img /> to detect if a src renders a valid image
 *
 * @param {String} [src = '']
 * @returns {Promise} - a promise object that resolves to true or false if the image loads or errors, respectively
 */
export var waitForImage = function (src) {
    if (src === void 0) { src = ''; }
    var img = new Image();
    img.style.display = 'none';
    img.style.height = '0';
    img.style.width = '0';
    var image = new Promise(function (resolve) {
        img.onload = function () {
            resolve(true);
        };
        img.onerror = function () {
            resolve(false);
        };
        img.src = src;
    })
        .finally(function () { return img.remove(); })
        .catch(function () { return false; });
    return image;
};
/**
 * Detect if the current device is touch enabled
 *
 * WARNING: We should always try a `css` media query solution when possible.
 * However, in cases when that isn't possible, this function is available.
 */
export var detectTouch = function () {
    var _a;
    if (!isBrowser())
        return false;
    return (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(hover: none), (pointer: coarse)').matches;
};
/**
 * Sanitizes a string to contain only numbers and formats those numbers into a beautified phone number.
 * @param {String} value String to format
 * @param {String} [locale=US] Desired locale for formatting (ISO 3166-1 alpha-2)
 * @returns {String} A formatted phone number
 */
export var formatPhone = function (value, locale) {
    if (locale === void 0) { locale = 'US'; }
    if (locale === 'US') {
        if (!value)
            return value;
        var phoneNumber = value.replace(/[^\d]/g, '');
        var phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4)
            return phoneNumber;
        if (phoneNumberLength < 7) {
            return "(".concat(phoneNumber.slice(0, 3), ") ").concat(phoneNumber.slice(3));
        }
        return "(".concat(phoneNumber.slice(0, 3), ") ").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6, 10));
    }
    return value;
};
/**
 *
 * @param {Object} variant Storefront ProductVariant object, contains different versions of a product
 * @returns {String} Formatted relative path to PDP with exact size and variant
 */
export var getProductVariantUrl = function (variant) {
    if (!variant) {
        return null;
    }
    var handle = variant.product.handle, selectedOptions = variant.selectedOptions;
    var options = selectedOptions.reduce(function (curr, option) {
        var name = option.name.replace(/\s+/g, '+').toLowerCase();
        var replacementCharacter = name === 'color' ? '-' : '+';
        var value = option.value
            .replace(/\s+/g, replacementCharacter)
            .toLowerCase();
        var query = "".concat(name === 'color' || name === 'value' ? 'variant' : name, "=").concat(value, "&");
        return curr + query;
    }, '');
    var queryString = options.slice(0, -1);
    return "/products/".concat(handle, "?").concat(queryString);
};
/**
 * Generates a top level domain for cross app cookies
 * @param {String} hostname current url hostname
 * @returns {{ .bombas.co.uk || .bombas.com || localhost || .bombas.fyi }}
 */
export var getCookieDomain = function () {
    var hostname = window.location.hostname;
    var rootDomain = hostname.substring(hostname.indexOf('bombas'));
    return "".concat(rootDomain !== 'localhost' ? '.' : '').concat(rootDomain);
};
/**
 * NOTE: this function is not currently in use.
 * Validates an email is a customer with 0 purchases and applies new customer
 * coupon upon success
 * @param {String} couponCode
 * @param {String} email
 */
export var applyNewCustomerCoupon = function (couponCode, email) {
    return post("".concat(platform_base_url, "/v1/marketing/email-sign-up"), {
        contact: { email: email }
    })
        .then(function () {
        PubSub.publish('cart.discountApply', couponCode);
        Cookies.set('optimizelyNewCustomerOfferEmailCaptureSuccess', 'true', {
            domain: getCookieDomain()
        });
    })
        .catch(function (e) {
        throw new Error(e);
    });
};
/**
 * Determines the error policy based on the provided query. This function is intended to be used
 * only within getServerSideProps functions.
 *
 * @param {Object} query - The query object from the context of getServerSideProps, which may have a `gql_error` property.
 * @param {string} query.gql_error - The GraphQL error status. If it's 'all', the function will return 'all'.
 *
 * @returns {string} - Returns 'none' if the query object is empty or if `gql_error` is not 'all'.
 * Otherwise, returns 'all'.
 */
export var getErrorPolicy = function (query) {
    if (query === void 0) { query = {}; }
    return Object.keys(query).length === 0
        ? 'none'
        : (query === null || query === void 0 ? void 0 : query.gql_error) === 'all'
            ? 'all'
            : 'none';
};
/**
 * Returns empty string if no `html` provided.
 * Otherwise it strips out all HTML tags and returns it.
 *
 * @param {string|null|undefined} html - HTML string input
 * @returns {string} - string without HTML tags
 */
export var stripHTMLTags = function (html) {
    if (!html)
        return '';
    return html.replace(/<[^>]*>?/gm, '');
};
/**
 * Clean and easy way to conditionally add an item to an array or object.
 * Intended to be paired with spread syntax.
 * @example [...insertIf(true, [1]), 2, 3] => [1, 2, 3]
 * @example {...insertIf(true, { hello: 'world' }), goodbye: 'earth' } => { hello: 'world', goodbye: 'earth' }
 */
export var insertIf = function (condition, result) {
    if (condition)
        return result;
    if (Array.isArray(result))
        return [];
    return {};
};
/**
 *  Compares two objects for deep equality.
 */
export var deepEqual = function (value1, value2) {
    if (value1 === value2)
        return true;
    // If either is not an object or is null, they are not equal
    if (value1 === null ||
        value2 === null ||
        typeof value1 !== 'object' ||
        typeof value2 !== 'object') {
        return false;
    }
    var keys1 = Object.keys(value1);
    var keys2 = Object.keys(value2);
    if (keys1.length !== keys2.length)
        return false;
    if (keys1.some(function (key) {
        return !keys2.includes(key) ||
            !deepEqual(value1[key], value2[key]);
    })) {
        return false;
    }
    return true;
};
/**
 * Client-side routing for hostnames on the same domain.
 *
 * Handles navigation to a target URL with support for both internal and external links.
 *
 * For internal links (same hostname), uses Next.js router for client-side navigation.
 * For external links, performs a full page navigation via window.location.
 *
 * When Ctrl/Cmd key is pressed during click, opens internal links in a new tab.
 *
 * @param router - Next.js router instance for client-side navigation
 * @param targetUrl - The URL to navigate to (can be relative or absolute)
 * @param event - Optional mouse event to detect modifier keys (Ctrl/Cmd for new tab)
 */
export var handleNavigate = function (router, targetUrl, event) {
    var url = isBrowser() && new URL(window.location.href);
    var _a = url instanceof URL ? url : {}, _b = _a.hostname, hostname = _b === void 0 ? '' : _b, _c = _a.origin, origin = _c === void 0 ? '' : _c;
    // some links in Contentful are relative urls, so we need a check for that
    var isRelativeUrl = /^\/(?!\/)/.test(targetUrl);
    // create a new URL object to get the hostname if path exists
    // if the url is relative, we need to use the origin of the current page
    // otherwise, we can use the url as is
    var pathHostname = (isRelativeUrl
        ? new URL(targetUrl, origin)
        : new URL(targetUrl)).hostname;
    // client-side routing if the path is on the same hostname
    // otherwise, navigate via window.location
    if (pathHostname === hostname) {
        if ((event === null || event === void 0 ? void 0 : event.ctrlKey) || (event === null || event === void 0 ? void 0 : event.metaKey)) {
            window.open(targetUrl, '_blank');
        }
        else {
            router.push(targetUrl);
        }
    }
    else {
        window.location.href = targetUrl;
    }
};
/**
 * Retrieves cookie and parses JSON value.
 * @param cookieName Name of the cookie to retrieve and parse value from
 * @param req (optional) - The API request object, used to extract cookie data server side.
 * @returns The parsed cookie value or null if the cookie does not exist or cannot be parsed.
 */
export var parseCookie = function (cookieName, req) {
    var _a;
    var cookieValue = (req && ((_a = req.cookies) === null || _a === void 0 ? void 0 : _a[cookieName])) ||
        (isBrowser() && Cookies.get(cookieName));
    if (cookieValue) {
        try {
            return JSON.parse(cookieValue);
        }
        catch (e) {
            // eslint-disable-next-line
            console.error("Failed to parse ".concat(cookieName, " cookie:"), e);
        }
    }
    return null;
};
/**
 * Higher-order function that ensures only one execution is allowed at a time to safeguard from race conditions.
 * @param fn Function to wrap with mutex
 * @returns Wrapped function
 */
export var withMutex = function (fn) {
    var mutexPromise = null;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (mutexPromise) {
                    return [2 /*return*/, mutexPromise];
                }
                mutexPromise = Promise.resolve(fn.apply(void 0, args)).finally(function () {
                    mutexPromise = null;
                });
                return [2 /*return*/, mutexPromise];
            });
        });
    };
};
export default {};
